import React, { useEffect, useState } from "react";
import axios from "axios";

import { useNavigate } from "react-router-dom";
import {
  FaListAlt,
  FaExchangeAlt,
  FaUser,
  FaMoneyBillWave,
  FaClipboardList,
  FaHandshake,
  FaShoppingBag,
  FaCheckCircle,   // ⭐ NEW ICON
} from "react-icons/fa";

import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import { API_BASE_URL } from "../config";


function Dashboard() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const [stripeStatus, setStripeStatus] = useState(null);
  const [swapUnread, setSwapUnread] = useState(0);
  const [swapDealUnread, setSwapDealUnread] = useState(0);
  const [purchaseUnread, setPurchaseUnread] = useState(0);
const [soldUnread, setSoldUnread] = useState(0);

  useEffect(() => {
  const fetchStripeStatus = async () => {
    try {
      const res = await axios.get(
       `${API_BASE_URL}/api/stripe/status`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setStripeStatus({ stripe_onboarded: res.data.connected ? 1 : 0 });
    } catch (err) {
      console.error("Failed to fetch Stripe status");
    }
  };

  fetchStripeStatus();
}, []);

useEffect(() => {
const fetchSwapUnread = async () => {
  try {
    const [mowingRes, cleaningRes, poolCareRes] = await Promise.all([
      axios.get(`${API_BASE_URL}/api/swaps/unread-count`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),

      axios.get(`${API_BASE_URL}/api/cleaning/swaps/unread-count`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),

      axios.get(`${API_BASE_URL}/api/poolcare/swaps/unread-count`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    ]);

    const mowingCount =
      mowingRes.data.success ? mowingRes.data.count || 0 : 0;

    const cleaningCount =
      cleaningRes.data.success ? cleaningRes.data.count || 0 : 0;

    const poolCareCount =
      poolCareRes.data.success ? poolCareRes.data.count || 0 : 0;

    setSwapUnread(
      mowingCount + cleaningCount + poolCareCount
    );

  } catch (err) {
    console.error("Failed to fetch swap unread count");
  }
};

const fetchSwapDealUnread = async () => {
  try {

    const [mowingRes, cleaningRes, poolCareRes] = await Promise.all([

      axios.get(`${API_BASE_URL}/api/swap-deals/action-count`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),

      axios.get(`${API_BASE_URL}/api/cleaning/swaps/deals/action-count`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),

      axios.get(`${API_BASE_URL}/api/poolcare/swaps/deals/action-count`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),

    ]);

    const mowingCount =
      mowingRes.data.success ? mowingRes.data.count || 0 : 0;

    const cleaningCount =
      cleaningRes.data.success ? cleaningRes.data.count || 0 : 0;

    const poolCareCount =
      poolCareRes.data.success ? poolCareRes.data.count || 0 : 0;

    setSwapDealUnread(
      mowingCount + cleaningCount + poolCareCount
    );

  } catch (err) {
    console.error("Failed to fetch swap deal alerts");
  }
};

const fetchHandoverUnread = async () => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));

    const res = await axios.get(
      `${API_BASE_URL}/api/handover/action-counts`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "user-id": user?.id,
        },
      }
    );

    if (res.data.success) {
      setPurchaseUnread(res.data.purchaseCount || 0);
      setSoldUnread(res.data.soldCount || 0);
    }
  } catch (err) {
    console.error("Failed to fetch handover alerts");
  }
};


fetchSwapUnread();
fetchSwapDealUnread();
fetchHandoverUnread();
}, []);



  const containerStyle = {
    maxWidth: "1200px",
    margin: "20px auto",
    padding: "0 20px",
  };

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "20px",
    marginTop: "30px",
  };

  const cardStyle = {
    background: "#fff",
    padding: "20px",
    borderRadius: "12px",
    border: "1px solid #e0e0e0",
    textAlign: "center",
    cursor: "pointer",
    position: "relative",
  };

  const iconStyle = {
    fontSize: "40px",
    color: "#2e7d32",
    marginBottom: "10px",
  };

  const badgeStyle = {
  position: "absolute",
  top: "10px",
  right: "10px",
  background: "#d32f2f",
  color: "#fff",
  borderRadius: "999px",
  minWidth: "24px",
  height: "24px",
  padding: "0 7px",
  fontSize: "13px",
  fontWeight: "bold",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

  return (
    <div style={containerStyle}>
      <h1 style={{ textAlign: "center", color: "#2e7d32" }}>
  Welcome back, {user?.name || "User"} 👋
</h1>

      {/* STRIPE STATUS */}
{stripeStatus && stripeStatus.stripe_onboarded !== 1 && (
  <div
    style={{
      background: "#fff3cd",
      border: "1px solid #ffeeba",
      padding: "16px",
      borderRadius: "8px",
      marginTop: "20px",
      textAlign: "center",
    }}
  >
    <strong>Stripe not connected</strong>
    <p style={{ marginTop: "8px" }}>
      You must connect Stripe to receive payments from buyers.
    </p>
    <button
      onClick={() => navigate("/connect-stripe")}
      style={{
        padding: "10px 20px",
        backgroundColor: "#2e7d32",
        color: "white",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
      }}
    >
      Connect Stripe
    </button>
  </div>
)}

{stripeStatus && stripeStatus.stripe_onboarded === 1 && (
  <div
    style={{
      background: "#e8f5e9",
      border: "1px solid #c8e6c9",
      padding: "16px",
      borderRadius: "8px",
      marginTop: "20px",
      textAlign: "center",
      color: "#1b5e20",
      fontWeight: "bold",
    }}
  >
    ✅ Stripe connected — payouts enabled
  </div>
)}


      <div style={gridStyle}>

        {/* VIEW LISTINGS */}
        <div style={cardStyle} onClick={() => navigate("/my-listings")}>
          <FaListAlt style={iconStyle} />
          <h3>Your Listings</h3>
        </div>

       {/* MY PURCHASES */}
<div style={cardStyle} onClick={() => navigate("/my-purchases")}>

  {purchaseUnread > 0 && (
    <div style={badgeStyle}>
      {purchaseUnread}
    </div>
  )}

  <FaShoppingBag style={iconStyle} />
  <h3>My Purchases</h3>
</div>

      {/* ⭐ NEW: MY SOLD CLIENTS */}
<div style={cardStyle} onClick={() => navigate("/my-sold")}>

  {soldUnread > 0 && (
    <div style={badgeStyle}>
      {soldUnread}
    </div>
  )}

  <FaCheckCircle style={iconStyle} />
  <h3>My Sold Clients</h3>
</div>
      


        {/* SWAP INBOX */}
<div style={cardStyle} onClick={() => navigate("/swap-inbox")}>

  {swapUnread > 0 && (
    <div style={badgeStyle}>
      {swapUnread}
    </div>
  )}

  <FaClipboardList style={iconStyle} />
  <h3>Swap Inbox</h3>
</div>

{/* MY SWAP DEALS */}
<div style={cardStyle} onClick={() => navigate("/my-swap-deals")}>

  {swapDealUnread > 0 && (
    <div style={badgeStyle}>
      {swapDealUnread}
    </div>
  )}

  <FaHandshake style={iconStyle} />
  <h3>My Swap Deals</h3>
</div>

        {/* PROFILE */}
        <div style={cardStyle} onClick={() => navigate("/profile")}>
          <FaUser style={iconStyle} />
          <h3>Profile & Verification</h3>
        </div>

        {/* POST A CLIENT */}
        <div style={cardStyle} onClick={() => navigate("/select-category")}>
          <FaMoneyBillWave style={iconStyle} />
          <h3>Sell or Swap Clients</h3>

        </div>

{/* CLIENT EXCHANGE PLUS */}
<div
  style={cardStyle}
  onClick={() => navigate("/plus")}
>
  <div
    style={{
      height: "60px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "10px",
    }}
  >
    <img
      src={logo}
      alt="Client Exchange Plus"
      style={{
        height: "170px",
        width: "auto",
        objectFit: "contain",
        filter:
  "brightness(0) saturate(100%) invert(22%) sepia(84%) saturate(520%) hue-rotate(86deg) brightness(78%) contrast(105%)",
// 👈 THIS MAKES IT GREEN
      }}
    />
  </div>

  <h3>Client Exchange Plus</h3>
</div>




      </div>
    </div>
  );
}

export default Dashboard;
